<template>
  <!-- new -->
  <section class="section_news">
    <div class="container">
      <!--      <h2>Breaking News</h2>-->
      <ul class="nav nav-tabs" id="newstablist" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            id="nflnews-tab"
            data-toggle="tab"
            href="#nflnews"
            role="tab"
            aria-controls="nflnews"
            aria-selected="true"
            >NFL</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="mlbnews-tab"
            data-toggle="tab"
            href="#mlbnews"
            role="tab"
            aria-controls="mlbnews"
            aria-selected="false"
            >MLB</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="nhlnews-tab"
            data-toggle="tab"
            href="#nhlnews"
            role="tab"
            aria-controls="nhlnews"
            aria-selected="false"
            >NHL</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="nbanews-tab"
            data-toggle="tab"
            href="#nbanews"
            role="tab"
            aria-controls="nbanews"
            aria-selected="false"
            >NBA</a
          >
        </li>
      </ul>

      <div class="tab-content" id="newstabContent">
        <!-- Nfl news -->
        <div
          class="tab-pane fade active show"
          id="nflnews"
          role="tabpanel"
          aria-labelledby="nflnews-tab"
        >
          <div class="tab-content-inner">
            <div class="row justify-content-center">
              <div class="col-md-4" v-for="news in NflNews" :key="news._id">
                <div class="news-box">
                  <div class="newsimg d-flex justify-lg-space-between">
                    <!--                    <v-col cols="3" md="3">-->
                    <!--                      <v-avatar-->
                    <!--                          :rounded="true"-->
                    <!--                          size="60"-->
                    <!--                          color="grey"-->
                    <!--                      >-->
                    <!--                        <img-->
                    <!--                            :src="news.PhotoUrl"-->
                    <!--                            alt="player_image"-->
                    <!--                        >-->
                    <!--                      </v-avatar>-->
                    <!--                    </v-col>-->
                    <v-col cols="3" md="3">
                      <v-avatar :rounded="true" size="60" color="grey">
                        <img :src="news.Teamlogo" alt="player_image" />
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <div style="text-decoration: none; color: #145c57">
                        {{ news.Title }}
                      </div>
                    </v-col>
                  </div>
                  <div class="news-content">
                    <router-link
                      target="_blank"
                      :to="{ name: 'NflDemoNewsPage' }"
                      style="text-decoration: none; color: #145c57"
                    >
                      <span class="text-truncate d-block black--text">{{
                        news.Content
                      }}</span>
                      <span class="green--text">{{
                        dateTimeFormat(news.Updated)
                      }}</span>
                    </router-link>
                  </div>
                </div>
              </div>

              <div v-if="hasMoreNflNews" class="row justify-content-center mt-4">
                <div class="col-md-12 text-center">
                  <v-btn
                    color="green darken-1"
                    dark
                    @click="showSubscriptionModal = true"
                  >
                    View More
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- NHL -->
        <div
          class="tab-pane fade"
          id="nhlnews"
          role="tabpanel"
          aria-labelledby="nhlnews-tab"
        >
          <div class="tab-content-inner">
            <div class="row justify-content-center">
              <div class="col-md-4" v-for="news in NhlNews" :key="news._id">
                <div class="news-box">
                  <div class="newsimg d-flex justify-lg-space-between">
                    <!--                    <v-col cols="3" md="3">-->
                    <!--                      <v-avatar-->
                    <!--                          :rounded="true"-->
                    <!--                          size="60"-->
                    <!--                          color="grey"-->
                    <!--                      >-->
                    <!--                        <img-->
                    <!--                            :src="news.PhotoUrl"-->
                    <!--                            alt="player_image"-->
                    <!--                        >-->
                    <!--                      </v-avatar>-->
                    <!--                    </v-col>-->
                    <v-col cols="3" md="3">
                      <v-avatar :rounded="true" size="60" color="grey">
                        <img :src="news.Teamlogo" alt="player_image" />
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <div style="text-decoration: none; color: #145c57">
                        {{ news.Title }}
                      </div>
                    </v-col>
                  </div>
                  <div class="news-content">
                    <router-link
                      :to="{ name: 'NhlDemoNewsPage' }"
                      style="text-decoration: none; color: #145c57"
                      target="_blank"
                    >
                      <span class="text-truncate d-block black--text">
                        {{ news.Content }}
                      </span>
                      <span class="green--text">{{
                        dateTimeFormat(news.Updated)
                      }}</span>
                    </router-link>
                  </div>
                </div>
              </div>

              <div v-if="hasMoreNhlNews" class="row justify-content-center mt-4">
                <div class="col-md-12 text-center">
                  <v-btn
                    color="green darken-1"
                    dark
                    @click="showSubscriptionModal = true"
                  >
                    View More
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- MLB -->
        <div
          class="tab-pane fade"
          id="mlbnews"
          role="tabpanel"
          aria-labelledby="mlbnews-tab"
        >
          <div class="tab-content-inner">
            <div class="row justify-content-center">
              <div class="col-md-4" v-for="news in MlbNews" :key="news._id">
                <div class="news-box">
                  <div class="newsimg d-flex justify-lg-space-between">
                    <!--                    <v-col cols="3" md="3">-->
                    <!--                      <v-avatar-->

                    <!--                          :rounded="true"-->
                    <!--                          size="60"-->
                    <!--                          color="grey"-->
                    <!--                      >-->
                    <!--                        <img-->
                    <!--                            :src="news.PhotoUrl"-->
                    <!--                            alt="player_image"-->
                    <!--                        >-->
                    <!--                      </v-avatar>-->
                    <!--                    </v-col>-->
                    <v-col cols="3" md="3">
                      <v-avatar :rounded="true" size="60" color="grey">
                        <img :src="news.Teamlogo" alt="player_image" />
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <div style="text-decoration: none; color: #145c57">
                        {{ news.Title }}
                      </div>
                    </v-col>
                  </div>
                  <div class="news-content">
                    <router-link
                      :to="{ name: 'MlbDemoNewsPage' }"
                      style="text-decoration: none; color: #145c57"
                      target="_blank"
                    >
                      <span class="text-truncate d-block black--text">
                        {{ news.Content }}
                      </span>
                      <span class="text-white green--text">{{
                        dateTimeFormat(news.Updated)
                      }}</span>
                    </router-link>
                  </div>
                </div>
              </div>

              <div v-if="hasMoreMlbNews" class="row justify-content-center mt-4">
                <div class="col-md-12 text-center">
                  <v-btn
                    color="green darken-1"
                    dark
                    @click="showSubscriptionModal = true"
                  >
                    View More
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- NBA -->
        <div
          class="tab-pane fade"
          id="nbanews"
          role="tabpanel"
          aria-labelledby="nbanews-tab"
        >
          <div class="tab-content-inner">
            <div class="row justify-content-center">
              <div class="col-md-4" v-for="news in NbaNews" :key="news._id">
                <div class="news-box">
                  <div class="newsimg d-flex justify-lg-space-between">
                    <!--                    <v-col cols="3" md="3">-->
                    <!--                      <v-avatar-->
                    <!--                          :rounded="true"-->
                    <!--                          size="60"-->
                    <!--                          color="grey"-->
                    <!--                      >-->
                    <!--                        <img-->
                    <!--                            :src="news.PhotoUrl"-->
                    <!--                            alt="player_image"-->
                    <!--                        >-->
                    <!--                      </v-avatar>-->
                    <!--                    </v-col>-->
                    <v-col cols="3" md="3">
                      <v-avatar :rounded="true" size="60" color="grey">
                        <img :src="news.Teamlogo" alt="player_image" />
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <div style="text-decoration: none; color: #145c57">
                        {{ news.Title }}
                      </div>
                    </v-col>
                  </div>
                  <div class="news-content">
                    <router-link
                      :to="{ name: 'NbaDemoNewsPage' }"
                      style="text-decoration: none; color: #145c57"
                      target="_blank"
                    >
                      <span class="text-truncate d-block black--text">
                        {{ news.Content }}
                      </span>
                      <span class="text-white green--text">{{
                        dateTimeFormat(news.Updated)
                      }}</span>
                    </router-link>
                  </div>
                </div>
              </div>

              <div v-if="hasMoreNbaNews" class="row justify-content-center mt-4">
                <div class="col-md-12 text-center">
                  <v-btn
                    color="green darken-1"
                    dark
                    @click="showSubscriptionModal = true"
                  >
                    View More
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--        <div class="blogfoot">-->
        <!--          <p>7 Day Free Trial To View More</p>-->
        <!--          <div class="blogsbtns">-->
        <!--            <a-->
        <!--                @click.prevent="goToPricing"-->
        <!--                style="cursor: pointer"-->
        <!--                class="viewmorbtn gredient_btn"-->
        <!--            >SIGN UP NOW</a-->
        <!--            >-->
        <!--            <a-->
        <!--                @click.prevent="goToPricing"-->
        <!--                style="cursor: pointer"-->
        <!--                class="viewmorbtn outloine_btn"-->
        <!--            >View More</a-->
        <!--            >-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>

    <news-subscription-modal
      :showModal="showSubscriptionModal"
      @close="showSubscriptionModal = false"
    />
  </section>
</template>

<script>
import { mapState } from "vuex";
import NewsSubscriptionModal from "@/components/Modal/NewsSubscriptionModal.vue";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  name: "NewsSection",

  components: {
    NewsSubscriptionModal,
  },

  data() {
    return {
      showSubscriptionModal: false,
    };
  },

  computed: {
    ...mapState("MlbModule", ["mlbNews"]),
    ...mapState("NbaModule", ["nbaNews"]),
    ...mapState("NflModule", ["nflNews"]),
    ...mapState("NhlModule", ["nhlNews"]),
    ...mapState("userModule", ["userState"]),

    planType() {
      return this.userState?.plantype || localStorage.getItem("planType") || "";
    },

    isFreeUser() {
      return this.planType === "Free" || this.planType === "";
    },

    newsLimit() {
      return this.isFreeUser ? 5 : 15;
    },

    NflNews() {
      if (this.nflNews.data) {
        return this.nflNews.data.slice(0, this.newsLimit);
      }
    },
    MlbNews() {
      if (this.mlbNews.data) {
        return this.mlbNews.data.slice(0, this.newsLimit);
      }
    },
    NbaNews() {
      if (this.nbaNews.data) {
        return this.nbaNews.data.slice(0, this.newsLimit);
      }
    },
    NhlNews() {
      if (this.nhlNews.data) {
        return this.nhlNews.data.slice(0, this.newsLimit);
      }
    },

    hasMoreNflNews() {
      return this.isFreeUser && this.nflNews.data && this.nflNews.data.length > 5;
    },
    hasMoreMlbNews() {
      return this.isFreeUser && this.mlbNews.data && this.mlbNews.data.length > 5;
    },
    hasMoreNbaNews() {
      return this.isFreeUser && this.nbaNews.data && this.nbaNews.data.length > 5;
    },
    hasMoreNhlNews() {
      return this.isFreeUser && this.nhlNews.data && this.nhlNews.data.length > 5;
    },
  },

  mounted() {
    Promise.race([
      this.fetchMlbNews(),
      this.fetchNbaNews(),
      this.fetchNflNews(),
      this.fetchNhlNews(),
    ]);
  },

  methods: {
    dateTimeFormat(value) {
      if (value) {
        return dayjs.utc(value).tz("America/New_York").format("MMM D, h:mm A");
      }
    },

    fetchMlbNews() {
      this.$store.dispatch("MlbModule/getMlbNews");
    },

    fetchNbaNews() {
      this.$store.dispatch("NbaModule/getNbaNewsData");
    },

    fetchNflNews() {
      this.$store.dispatch("NflModule/getNflNewsData");
    },

    fetchNhlNews() {
      this.$store.dispatch("NhlModule/getNhlNewsData");
    },

    estTime(value) {
      const datetime = new Date(value);
      const time = datetime.toLocaleString("en-US", {
        timeZone: "America/New_York",
      });

      console.log(time);
    },

    goToPricing() {
      // As you said that we need to Hid it from free user & only paid user can access more than 3 news !!
      window.location.href = `https://app.fantasylineups.com?utm_source=${localStorage.getItem(
        "utm_source"
      )}&utm_campaign=${localStorage.getItem(
        "utm_campaign"
      )}&utm_medium=${localStorage.getItem(
        "utm_medium"
      )}&utm_term=${localStorage.getItem(
        "utm_term"
      )}&utm_content=${localStorage.getItem("utm_content")}`;
    },
  },
};
</script>

<style scoped></style>
